import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from "@/constants/legalLinks.constants";
import { useTranslation } from "@/core/i18n";
import { openUrl } from "@/utils/openUrl/openUrl";

// Terms of Service + Privacy Policy links rendered *inside* an SMS opt-in disclosure block.
// Twilio's compliance review (2026-07) rejected footer-only links: they are a required part
// of the opt-in disclosure itself, for both the transactional and the marketing opt-in.
//
// Labels reuse the existing `repeatmdFooter.*` keys — already translated in every supported
// locale — so the wording stays identical to the footer instead of forking a second set of
// strings that can drift.
//
// Opened through `openUrl` (Browser.open on native, window.open on web) rather than <a> tags,
// so the links behave correctly in the native shell without the Android deep-link workaround
// anchors need. Callers must place this OUTSIDE the Checkbox's <label> — anything clickable
// inside that label toggles the consent checkbox.
type SmsComplianceLinksProps = {
  className?: string;
};

export const SmsComplianceLinks = ({ className = "" }: SmsComplianceLinksProps) => {
  const { t } = useTranslation();

  return (
    <div className={`flex items-center gap-1.5 text-[11px] leading-4 ${className}`}>
      <button
        type="button"
        className="text-brand-color underline"
        onClick={() => openUrl(TERMS_OF_SERVICE_URL)}
      >
        {t("repeatmdFooter.termsOfService")}
      </button>
      <span aria-hidden="true" className="text-secondary">
        |
      </span>
      <button
        type="button"
        className="text-brand-color underline"
        onClick={() => openUrl(PRIVACY_POLICY_URL)}
      >
        {t("repeatmdFooter.privacyPolicy")}
      </button>
    </div>
  );
};
